module.exports = __webpack_public_path__ + "images/55fad19c41b8189b3a43c2c45000321c.gif";